import { createFileRoute, redirect } from '@tanstack/react-router'
import { meQueryKey } from '@pa/staff'
import { impersonationFromHash } from '@/features/impersonation'

/**
 * The impersonation landing (Frontend §6.4 step 1; D-40): `/impersonate#imp={id}`, opened by S-06 in the same tab.
 * The id goes to `sessionStorage`, and the redirect to `/` replaces this history entry, so the fragment leaves the
 * URL. Then the guards: A-01 first if this origin isn't signed in yet, then the impersonated clinic.
 */
export const Route = createFileRoute('/impersonate')({
  beforeLoad: ({ context, location }) => {
    const id = impersonationFromHash(location.hash)
    if (id) {
      context.impersonation.start(id)
      // `/v1/me` must be read again, with the header.
      context.queryClient.removeQueries({ queryKey: meQueryKey() })
    }
    redirect({ href: '/', replace: true, throw: true })
  },
})
